module.exports = __webpack_public_path__ + "media/images/tiedye/design-2-58f356bc2ff665309a187e9172904eb1.jpg";